// |waPhoneList|
import { doorClient, ImResponse, messDoorClient, resolve } from '.';

export interface IPhoneListReq {
  keyword?: string;
  platform?: 'SHOPEE' | 'LAZADA';
  region?: General.UpperCaseRegion;
  pageNum: string;
  pageSize: string;
}

export interface IPhoneListRsp {
  totalPages: 'SHOPEE' | 'LAZADA';
  totalRows: string;
  pageNum: string;
  pageSize: string;
  data: {
    phone: string;
    region: General.UpperCaseRegion;
    remark: string;
    lastWaba: string;
    lastChatTime: string;
    buyers: {
      platform: string;
      region: General.UpperCaseRegion;
      buyerNick: string;
      storeName: string;
    }[];
  }[];
}

export function waPhoneList(params: IPhoneListReq) {
  return resolve(
    messDoorClient.get<ImResponse<IPhoneListRsp>>(`/oversea-user/phoneList`, { params }),
  );
}

interface IBuyerReq {
  platform: 'SHOPEE' | 'LAZADA';
  region: General.UpperCaseRegion;
  buyerNick: string;
}

export function waBuyerBind(body: IBuyerReq) {
  return resolve(messDoorClient.put(`/oversea-user/buyer`, body));
}

export function waBuyerUpload(file: FormData) {
  return resolve(messDoorClient.post<ImResponse<number>>(`/oversea-user/buyer`, file));
}

interface IBuyerCommentReq {
  phone: string;
  remark: string;
}

export function waBuyerComment(body: IBuyerCommentReq) {
  return resolve(doorClient.put<ImResponse<number>>(`/oversea-user/phone`, body));
}
